module.exports = __webpack_public_path__ + "static/media/drum-wise-logo.203e7ff9.png";